import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AppLayout } from "@/components/AppLayout";
import { Toaster } from "@/components/ui/sonner";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Workspace from "@/pages/Workspace";
import TeamCalendar from "@/pages/TeamCalendar";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import ExecutiveHub from "@/pages/ExecutiveHub";
import UserManagement from "@/pages/UserManagement";
import Profile from "@/pages/Profile";
import SOPs from "@/pages/SOPs";
import IAMSocial from "@/pages/IAMSocial";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import Leads from "@/pages/Leads";
import Inbox from "@/pages/Inbox";
import Assets from "@/pages/Assets";
import Automations from "@/pages/Automations";
import Faturacao from "@/pages/Faturacao";

function Shell({ children, roles }) {
  return (
    <ProtectedRoute roles={roles}>
      <AppLayout>{children}</AppLayout>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false}>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<Shell><Dashboard /></Shell>} />
              <Route path="/workspace" element={<Shell><Workspace /></Shell>} />
              <Route path="/agenda" element={<Shell><TeamCalendar /></Shell>} />
              <Route path="/clientes" element={<Shell><Clients /></Shell>} />
              <Route path="/clientes/:id" element={<Shell><ClientDetail /></Shell>} />
              <Route path="/hub" element={<Shell roles={["ADMIN"]}><ExecutiveHub /></Shell>} />
              <Route path="/faturacao" element={<Shell roles={["ADMIN", "FINANCE"]}><Faturacao /></Shell>} />
              {/* Aberta a toda a equipa: qualquer pessoa pode dar entrada de um
                  colega. As ações de gestão são filtradas dentro da página. */}
              <Route path="/utilizadores" element={<Shell><UserManagement /></Shell>} />
              <Route path="/perfil" element={<Shell><Profile /></Shell>} />
              <Route path="/sops" element={<Shell><SOPs /></Shell>} />
              <Route path="/iam-social" element={<Shell><IAMSocial /></Shell>} />
              <Route path="/projetos" element={<Shell><Projects /></Shell>} />
              <Route path="/projetos/:id" element={<Shell><ProjectDetail /></Shell>} />
              <Route path="/comercial" element={<Shell><Leads /></Shell>} />
              <Route path="/inbox" element={<Shell><Inbox /></Shell>} />
              <Route path="/biblioteca" element={<Shell><Assets /></Shell>} />
              <Route path="/automacoes" element={<Shell roles={["ADMIN", "SUB_ADMIN"]}><Automations /></Shell>} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </div>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
